import { CopyIcon } from "@/constants/image";
import { IShareProps } from "@components/Share/index";
import { Tooltip } from "antd";
import { useState } from "react";

const CopyLink = ({ url }: IShareProps) => {
  const [isShowTooltip, setShowTooltip] = useState(false);
  const isClient = typeof window !== "undefined";

  const onCopy = () => {
    if (isClient && navigator.clipboard) {
      navigator.clipboard.writeText(url).then(() => {
        setTimeout(() => setShowTooltip(false), 1500);
        setShowTooltip(true);
      });
    }
  };

  return (
    <>
      <Tooltip title={"Đã sao chép"} open={isShowTooltip} arrow={false}>
        <div
          className="flex items-center p-3 rounded-lg cursor-pointer duration-300 hover:bg-grey-50"
          onClick={onCopy}>
          <img src={CopyIcon} alt="CopyIcon" />
          <span className="ml-3 text-fs-14 text-grey-800 font-medium">
            Sao chép liên kết
          </span>
        </div>
      </Tooltip>
    </>
  );
};

export default CopyLink;
